import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-article-image',
  templateUrl: './article-image.component.html',
  styleUrls: ['./article-image.component.css'],
  imports: [CommonModule],
})
export class ArticleImageComponent {
  src = input.required<string>();
  expand = input<boolean>(false);
}
